import { createUseStyles } from 'react-jss';

export default createUseStyles(() => ({
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 100
  },
  content: {
    margin: '0 0.5em',
    flex: 3
  }
}));
